<div class="row sticky-top bg-white" style="top:6.125rem">
  <div class="col-md-12">
    <app-alerting></app-alerting>
  </div>
</div>

<div class="row narrow-gutters always-enabled mt-3 mb-0">
  <div class="col-auto">
    <app-commercial-release-filter (changed)="applyTransitFilters($event)" [commercialReleases]="getFilteredItems()">
    </app-commercial-release-filter>
  </div>
  <div class="col-md-4" style="min-width: 19rem">
    <app-date-range (ngModelChange)="onDateSelection($event)" [ngModel]="dateRange" [disabled]="!!filterTerm">
    </app-date-range>
  </div>
  <div class="col">
    <app-filter class="mb-4" (resultsFound)="renderFilteredItems()" [(ngModel)]="filterTerm" [searchFunction]="reload"
                placeholder="Filter by B/L nr, container nr, etc..." [appAutoFocus]="true"></app-filter>
  </div>
  @if (appContext.isCommercialReleaseDeclarant()) {
    <div class="col-auto">
      <div class="btn-group">
        <button class="btn btn-outline-info" (click)="uploadButton.click()">
          <span class="fa fa-upload"></span>
          <input type="file" hidden (change)="uploadCommercialReleases($event.target);" #uploadButton>
        </button>
        <button type="button" class="btn btn-outline-info dropdown-toggle dropdown-toggle-split"
                data-bs-toggle="dropdown">
        </button>
        <div class="dropdown-menu dropdown-menu-end">
          <a href="/assets/templates/commercial-release-upload-v1.1.xlsx" class="dropdown-item">
            <i class="far fa-file-excel me-1" aria-hidden="true"></i>
            Download template
          </a>
        </div>
      </div>
    </div>
  }
  @if (appContext.isAllowedToAddCommercialRelease()) {
    <div class="col-auto">
      <button (click)="addNewRelease()" class="btn btn-info" tabindex="-1"><span class="pe-2 fa fa-plus-circle"></span>
        New release
      </button>
    </div>
  }
</div>

@if (visibleReleases; as releases) {
  <div class="d-flex flex-column align-items-stretch w-100 position-relative">
    <app-pagination #pagination [items]="commercialReleases" [maxSize]="40" class="accordion" id="releaseAccordion"
                    style="margin-bottom: 80px">
      @for (summary of pagination.getItemsOnPage(); track summary.id) {
        <div class="row g-0">
          @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor()) {
            <div class="col-auto me-2"
            >
              <div class="form-check form-check-inline m-0 always-enabled" style="height: 2rem">
                <input [(ngModel)]="summary['selected']" class="always-enabled form-check-input m-0" type="checkbox">
              </div>
            </div>
          }
          <div class="col">
            <app-collapse #releaseCollapse [collapse]="content" [showOnLoad]="isNewDeclaration(summary)"
                          [deleteHandle]="isNewDeclaration(summary) && removeNewDeclaration(summary)">
              <div class="row py-1 px-3 align-items-center text-dark">
                <div class="col text-truncate" title="Equipment number">
                  <span class="fa fa-fw fa-cube"></span>
                  {{ summary.releaseData?.equipmentNumber || 'New declaration' }}
                </div>
                <div class="col-2 d-none d-lg-block text-truncate" title="Consignment (B/L) number">
                  @if (!!summary.releaseData.consignmentNumber) {
                    <span class="fa fa-fw fa-file-invoice"></span>
                  }
                  {{ summary.releaseData.consignmentNumber }}
                </div>
                @if (!appContext.isHinterlandTerminal()) {
                  <div
                    class="col d-none d-md-block small text-secondary text-truncate" title="Terminal">
                    @if (!!summary.releaseData.terminalShortName) {
                      <span class="fa fa-sign-in-alt"></span>
                    }
                    {{ fixForMatrans(summary.releaseData.terminalShortName) }}
                  </div>
                }
                <div class="col d-none d-lg-block small text-secondary text-truncate" title="Container operator">
                  @if (summary.releaseData?.containerOperator?.cargoDeclarantShortName &&
                  appContext.userProfile.organisation?.shortName !==
                  summary.releaseData?.containerOperator?.cargoDeclarantShortName) {
                    <span class="fa fa-ship"></span>
                    {{ summary.releaseData?.containerOperator?.cargoDeclarantShortName }}
                  }
                </div>
                <div class="col small text-secondary text-truncate" title="Release-to party">
                  @if (!!summary.releaseData.releaseToParty) {
                    <span class="fa fa-truck"></span>
                  }
                  {{ summary.releaseData.releaseToParty?.name }}
                </div>
                <div class="col d-none d-lg-block small text-secondary text-truncate" title="Declaration date">
                  @if (summary.releaseStatus?.declarationDate) {
                    <span class="fa fa-paper-plane"></span>
                    {{ summary.releaseStatus.declarationDate | date:'dd-MM-YYYY' }}
                  }
                </div>
                <div class="col d-none d-lg-block small text-secondary text-truncate" title="Call reference number">
                  @if (!!summary.crn) {
                    <span class="fas fa-route"></span>
                  }
                  {{ summary.crn }}
                </div>
                <div class="col-1 text-end d-none d-md-block text-dark">
                  <app-commercial-release-summary [setModel]="summary" [keepTooltipOpen]="releaseCollapse.showing">
                  </app-commercial-release-summary>
                </div>
              </div>
            </app-collapse>
          </div>
        </div>
        <ng-template #content>
          <app-commercial-release-declaration [release]="summary"></app-commercial-release-declaration>
        </ng-template>
      }
      <div class="row g-0 text-secondary">
        @if ((appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor())
        && releases.length > 1) {
          <div class="col-auto">
            <label class="mt-3">
              <input [checked]="selectedItems.length === releases.length && releases.length > 0"
                     (click)="toggleSelectAll()" class="always-enabled" type="checkbox">
              <span class="ms-2">Select all</span>
            </label>
          </div>
        }
      </div>
    </app-pagination>
    @if (selectedItems.length > 0) {
      <div class="position-absolute bottom-0 vw-100 row g-0 justify-content-center bg-white py-3 border-top">
        <div class="col-auto mx-1">
          <app-confirmation-toggle>
            <button class="btn btn-outline-danger" style="min-width: 10rem" type="button">Cancel</button>
            <div class="modal-content">
              <div class="modal-header"><h5 class="modal-title">Send cancel request to terminal</h5></div>
              <div class="modal-body"><p>Are you sure that you want to cancel all accepted releases?</p></div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelSelected()">
                  Cancel releases
                </button>
              </div>
            </div>
          </app-confirmation-toggle>
        </div>
        <div class="col-auto mx-1">
          <button class="btn btn-outline-info" style="min-width: 10rem" type="button" (click)="exportSelected()">
            Export
          </button>
        </div>
        <div class="col-auto mx-1">
          <button class="btn btn-outline-info" style="min-width: 10rem" type="button"
                  (click)="redeclareCommercialReleases()">Change terminal
          </button>
        </div>
      </div>
    }
  </div>
  @if (visibleReleases.length === 0) {
    <div class="text-center text-muted py-2">
      @if (items.length > 0) {
        No matching releases found.
      } @else {
        You haven’t added any releases yet.
      }
      <ng-template #noReleasesYet>You haven’t added any releases yet.</ng-template>
    </div>
  }
}

<ng-template #bulkRedeclareBody>
  <p>
    You are about to change the terminal of the commercial releases below (<b>{{ selectedItems.length }} items</b>).
    <br/>
    Please check if all consignment – container numbers are correct <br/>
    <b>NOTE: Changes are not immediately visible and can take some minutes.</b>
  </p>
  <ul class="row">
    @for (commercialRelease of selectedItems; track commercialRelease.id) {
      <li class="col-6">
        {{ commercialRelease.releaseData?.consignmentNumber }} – {{ commercialRelease.releaseData?.equipmentNumber }}
      </li>
    }
  </ul>
  <div class="row gy-4">
    <app-form-group label="Terminal">
      <app-select required [(ngModel)]="redeclareData.terminalShortName" [options]="terminals"></app-select>
    </app-form-group>
  </div>
</ng-template>

<ng-template #uploadReleasesBody>
  @if (!uploadedReleases || uploadedReleases.length <= 10) {
    <p><span>You are about to bulk declare the following releases</span></p>
    <ul>
      @for (release of uploadedReleases; track trackByUploadRecord(release)) {
        <li>
          Release: {{ release.equipmentNumber }}
        </li>
      }
    </ul>
  } @else {
    <p>
      <span>You are about to bulk declare {{ uploadedReleases.length }} releases.</span>
    </p>
    <ul>
      <li>First release: {{ uploadedReleases[0].equipmentNumber }}</li>
      <li>{{ uploadedReleases.length - 2 }} releases...</li>
      <li>Last release: {{ uploadedReleases[uploadedReleases.length - 1].equipmentNumber }}</li>
    </ul>
  }
  <ng-template #multipleRows>
    <p>
      <span>You are about to bulk declare {{ uploadedReleases.length }} releases.</span>
    </p>
    <ul>
      <li>First release: {{ uploadedReleases[0].equipmentNumber }}</li>
      <li>{{ uploadedReleases.length - 2 }} releases...</li>
      <li>Last release: {{ uploadedReleases[uploadedReleases.length - 1].equipmentNumber }}</li>
    </ul>
  </ng-template>
  <p class="fw-bold">Are you sure you want to execute this action?</p>
</ng-template>
